export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"16\" fill=\"#C9CBD4\" stroke=\"#fff\" stroke-width=\"4\"/><g clip-path=\"url(#a)\"><path d=\"M25 11H11a1 1 0 000 2v11a1 1 0 002 0v-5.544a.456.456 0 01.456-.456h9.088a.456.456 0 01.456.456V24a1 1 0 002 0V13a1 1 0 000-2z\" fill=\"#fff\"/><path d=\"M19.227 16h-2a1 1 0 010-2h2a1 1 0 010 2z\" fill=\"#C9CBD4\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(10 10)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};